export default "__VITE_ASSET__gWmFQusf__"